<template>
  <div
    class="modal fade"
    id="passQualified"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h3 class="modal-title" id="myModalLabel">Pass Qualified</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="content-form">
            <div class="input-group mb-3">
              <input
                type="number"
                max="100"
                class="form-control"
                v-model="min_qual_percentage"
                @input="sanitizeValue($event)"
                @keydown="preventInvalidKeys"
              />
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">%</span>
              </div>
            </div>
            <div class="form-group">
              <button
                class="btn btn-cp ml-2 ml-0 btn-block"
                type="button"
                @click="passQualified"
              >
                Check Pass Qualified
              </button>
            </div>
          </form>
          <div class="form-group">
            <p v-if="isEventView" class="ml-3">
              <b>Scheduled applicants in selected Event: </b>
              {{ pendingApplicantIds.length }}
            </p>
            <p v-else class="ml-3">
              <b>Scheduled applicants in selected slot: </b>
              {{ pendingApplicantIds.length }}
            </p>
            <p class="ml-3"><b>Passed: </b> {{ passedApplicants.length }}</p>
            <p class="ml-3"><b>Failed: </b> {{ failedApplicants.length }}</p>
            <p class="ml-3"><b>Absent: </b> {{ absentApplicants ?? 0 }}</p>
          </div>
          <div>
            <div class="form-group">
              <div class="col-sm-9">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="control-label"
                    >Select Mail Template for Passed Applicants</label
                  >
                </div>
                <select
                  class="custom-select main college mr-2"
                  v-model="pass_mail_template"
                >
                  <option disabled value="">Select Mail Template</option>
                  <option
                    v-for="(mailTemplate, index) in applicationStatusTemplates"
                    :value="mailTemplate.id"
                    :key="index"
                  >
                    {{ mailTemplate.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-9">
                <label class="checkbox-inline" style="margin-top: 5px">
                  <input type="checkbox" v-model="sendMailToFailedApplicant" />
                  Send Mail to failed applicants
                </label>
                <div
                  v-if="sendMailToFailedApplicant"
                  class="d-flex justify-content-between align-items-center"
                >
                  <label class="control-label"
                    >Select Mail Template for Failed Applicants</label
                  >
                </div>
                <select
                  v-show="sendMailToFailedApplicant"
                  class="custom-select main college mr-2"
                  v-model="fail_mail_template"
                >
                  <option disabled value="">Select Mail Template</option>
                  <option
                    v-for="(mailTemplate, index) in applicationStatusTemplates"
                    :value="mailTemplate.id"
                    :key="index"
                  >
                    {{ mailTemplate.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-dark btn-sm"
            data-dismiss="modal"
            @click="$emit('canceled')"
          >
            <strong>Cancel</strong>
          </button>
          <button
            :disabled="
              (passedApplicants.length == 0 && failedApplicants.length == 0) ||
              !pass_mail_template ||
              (sendMailToFailedApplicant && !fail_mail_template)
            "
            type="button"
            class="btn btn-cp ml-2"
            @click="submit"
          >
            <i class="fa fa-book fa-lg" aria-hidden="true"></i>
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "../_api/index";

/**
 * @memberOf module:ApplicantProfile
 * @namespace components.add_round_modal
 * @description Add round modal component
 */
export default {
  props: [
    "eventId",
    "selectedSlotData",
    "pendingApplicantIds",
    "selectedCampusEventData",
    "isEventView",
  ],
  data() {
    return {
      passedApplicants: [],
      failedApplicants: [],
      absentApplicants: 0,
      min_qual_percentage: 75,
      pass_mail_template: null,
      fail_mail_template: null,
      sendMailToFailedApplicant: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      mailTemplates: "$_mailbox/getTemplates",
    }),
    applicationStatusTemplates() {
      if (this.mailTemplates) {
        return this.mailTemplates.filter((mail) => {
          return mail.key == "Application Status";
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    getAllMailTemplates() {
      this.$store.dispatch("$_mailbox/getTemplates");
    },
    sanitizeValue(event) {
      let v = event.target.value;
      v = v.replace(/\D/g, ""); // remove non-digits—essential for paste handling
      if (v.length > 2 && v != "100") {
        v = v.slice(0, 2); // limit to 2 digits
        this.$store.dispatch("openSnackbar", {
          type: "danger",
          message: "Minimum percentage must be a maximum of 2 digits.",
        });
      }
      event.target.value = v;
      this.min_qual_percentage = v ? Number(v) : "";
    },
    preventInvalidKeys(event) {
      const invalidKeys = ["e", "E", "+", "-", "."];
      if (invalidKeys.includes(event.key)) {
        event.preventDefault();
      }

      const current = event.target.value;
      const newValue = current + event.key;

      const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
      if (allowedKeys.includes(event.key)) return;

      if (newValue === "100") return;

      if (current.length >= 2) event.preventDefault();
    },
    passQualified() {
      api
        .passQualified(
          this.pendingApplicantIds,
          this.min_qual_percentage,
          this.eventId
        )
        .then((res) => {
          this.passedApplicants = res.data.passedApplicant;
          this.failedApplicants = res.data.failedApplicant;
          this.absentApplicants = res.data.absentApplicant;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submit() {
      const data = {
        minQualPercent: this.min_qual_percentage,
        applicantIds: this.pendingApplicantIds,
        passedApplicant: this.passedApplicants,
        failedApplicant: this.failedApplicants,
        eventId: this.eventId,
        pass_mail_template: this.pass_mail_template,
        fail_mail_template: this.fail_mail_template,
        sendMailToFailedApplicant: this.sendMailToFailedApplicant,
      };
      if (this.selectedSlotData) {
        data.slotsMasterId = this.selectedSlotData.id;
        api
          .updateApplicantStatusSlot(data)
          .then(() => {
            this.passedApplicants = [];
            this.failedApplicants = [];
            this.absentApplicants = 0;
            this.min_qual_percentage = 75;
            this.sendMailToFailedApplicant = false;
            this.pass_mail_template = null;
            this.fail_mail_template = null;
            this.$emit("submitted");
          })
          .catch((err) => {
            console.error(err);
          });
      } else if (this.selectedCampusEventData) {
        api
          .updateApplicantStatusEvent(data)
          .then(() => {
            this.passedApplicants = [];
            this.failedApplicants = [];
            this.absentApplicants = 0;
            this.min_qual_percentage = 75;
            this.sendMailToFailedApplicant = false;
            this.pass_mail_template = null;
            this.fail_mail_template = null;
            this.$emit("submitted");
          })
          .catch((err) => {
            console.error(err);
          });
      }
      $("#passQualified").modal("hide");
    },
  },
  beforeMount() {},
  mounted() {
    $("#passQualified").on("shown.bs.modal", () => {
      this.getAllMailTemplates();
    });
    $("#passQualified").on("hidden.bs.modal", () => {
      this.passedApplicants = [];
      this.failedApplicants = [];
      this.min_qual_percentage = 75;
    });
  },
  beforeDestroy() {
    $("#passQualified").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
};
</script>

<style scoped>
.custom-btn-gray {
  height: 35px;
  display: flex;
  align-items: center;
}

.custom-input {
  height: 35px;
  max-width: 60px;
  padding-right: 10px;
  padding-left: 10px;
  border: 0;
  color: #000;
  background-color: #ccc;
  border-radius: 4px;
}
</style>
